import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_Salary_Interface, Salary_Interface } from 'src/app/Interface/Salary_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { SalaryService } from 'src/app/Service/Salary/Salary.service';

@Component({
  selector: 'app-SalaryBaseForm',
  templateUrl: './SalaryBaseForm.component.html',
  styleUrls: ['./SalaryBaseForm.component.scss']
})
export class SalaryBaseFormComponent implements OnInit {

  @Input() inner_Year:number=0
  @Output() outter_Salary= new EventEmitter<number>();

  constructor(
    private Salary_Service: SalaryService,
    private Alertify_Service: AlertifyService
  ) { }

  ngOnInit() {

    this.AddNewSalary = new FormGroup({
      id: new FormControl(),
      BonKargari: new FormControl(null, Validators.required),
      Maskan: new FormControl(null, Validators.required),
      Kharbar: new FormControl(null, Validators.required),
      Tahahol: new FormControl(null, Validators.required),
      Payeh: new FormControl(null, Validators.required),
      Farzand: new FormControl(null, Validators.required),
      Paziraee: new FormControl(null, Validators.required),
    })

    this.OnGetData()
  }



  OnGetData() {
    this.Salary_Service.GetSingle(this.inner_Year).subscribe(
      data => {

        this.get_Form_BonKargari().setValue(data['bonKargari'])
        this.get_Form_Maskan().setValue(data['maskan'])
        this.get_Form_Kharbar().setValue(data['kharbar'])
        this.get_Form_Tahahol().setValue(data['tahahol'])
        this.get_Form_Farzand().setValue(data['farzand'])
        this.get_Form_Payeh().setValue(data['payeh'])
        this.get_Form_Paziraee().setValue(data['paziraee'])
      }
    )
  }



  //#region  Form Add

  AddNewSalary: FormGroup;

  get_Form_BonKargari() {
    return this.AddNewSalary.get('BonKargari') as FormControl;
  }

  get_Form_Maskan() {
    return this.AddNewSalary.get('Maskan') as FormControl;
  }

  get_Form_Kharbar() {
    return this.AddNewSalary.get('Kharbar') as FormControl;
  }

  get_Form_Tahahol() {
    return this.AddNewSalary.get('Tahahol') as FormControl;
  }


  get_Form_Farzand() {
    return this.AddNewSalary.get('Farzand') as FormControl;
  }
 
  get_Form_Payeh() {
    return this.AddNewSalary.get('Payeh') as FormControl;
  }

  get_Form_Paziraee() {
    return this.AddNewSalary.get('Paziraee') as FormControl;
  }


  //#endregion

  InProccessing: boolean = false

  SubmitAddNewSalary() {
    var Record: Salary_Interface=Empty_Salary_Interface()
    Record.year = this.inner_Year
    Record.id = 0
    Record.bonKargari = Number(this.get_Form_BonKargari().value)
    Record.maskan = Number(this.get_Form_Maskan().value)
    Record.kharbar = Number(this.get_Form_Kharbar().value)
    Record.tahahol = Number(this.get_Form_Tahahol().value)
    Record.payeh = Number(this.get_Form_Payeh().value)
    Record.farzand = Number(this.get_Form_Farzand().value)
    Record.paziraee = Number(this.get_Form_Paziraee().value)



    this.InProccessing = true
    this.Salary_Service.Add(Record).subscribe(
      data => {
        this.InProccessing = false
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  onBack(){
    this.outter_Salary.emit(-1);
  }

}
